import { Paths } from "@constants/paths";
import { cn } from "kz-ui-sdk";
import { useNavigate } from "react-router-dom";
import { OnboardingDialogStep } from "../../constants";
import { OnboardingDialogProps } from "../../types";
import { DialogController } from "../DialogController/DialogController";
import { BankAccountStep, ForgotSecretStep, LoginStep, OnboardStep, RegisterStep } from "./components";

const DialogPhonePin = ({
  isOpen,
  handleClose,
  stepNavigate,
  onboardingMode,
  step,
  callback,
  layout,
}: OnboardingDialogProps) => {
  const routerNavigate = useNavigate();

  return (
    <DialogController
      layout={layout}
      isOpen={isOpen}
      onClose={handleClose}
      classes={{
        drawer: {
          "container&": cn("!px-4", {
            "!pb-4": step === OnboardingDialogStep.Onboarding && onboardingMode,
          }),
        },
      }}
    >
      {/*ONBOARDING STEP*/}
      {step === OnboardingDialogStep.Onboarding && onboardingMode && (
        <OnboardStep
          defaultMode={onboardingMode}
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*LOGIN STEP*/}
      {step === OnboardingDialogStep.Login && (
        <LoginStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*REGISTER STEP*/}
      {step === OnboardingDialogStep.Register && (
        <RegisterStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*FORGOT PIN STEP*/}
      {step === OnboardingDialogStep.ForgotSecret && (
        <ForgotSecretStep
          navigate={stepNavigate}
          handleClose={handleClose}
          layout={layout}
        />
      )}

      {/*BANK ACCOUNT STEP*/}
      {[OnboardingDialogStep.UpdateBankAccount, OnboardingDialogStep.AddBankAccount].includes(step) && (
        <BankAccountStep
          navigate={stepNavigate}
          onUpdateSuccess={() => {
            if (callback) {
              callback();
            }
            routerNavigate(Paths.PRIVATE.HOME);
          }}
          handleClose={handleClose}
          layout={layout}
          step={step}
        />
      )}
    </DialogController>
  );
};

export default DialogPhonePin;
